import { IAlbusApis } from "./IAlbusApis";
import AlbusApis from "./AlbusApis";
import { IOrionApis } from "./IOrionApis"
import OrionApis from "./OrionApis"
import { IRamsayApis } from "./IRamsayApis";
import RamsayApis from "./RamsayApis";
import { IPolarisApis } from "./IPolarisApis";
import PolarisApis from "./PolarisApis";
import { IMaverickApis } from "./IMaverickApis";
import MaverickApis from "./MaverickApis";
import { IMetricServiceApis } from "./IMetricServiceApis";
import MetricServiceApis from "./MetricServiceApis";
import { ISubuserApis } from "./ISubuserApis";
import SubuserApis from "./SubuserApis";
import OllivanderApis from "./OllivanderApis";
import EHRApis from "./EHRApis";
import { IEHRApis } from "./IEHRApis";
import CareRecommendationServiceApis from "./CareRecommendationServiceApis";
import { ICareRecommendationServiceApis } from "./ICareRecommendationServiceApis";
import { IUserFitnessApis } from "./UserFitnessService/IUserFitnessApis";
import UserFitnessApis from "./UserFitnessService/UserFitnessApis";

export class ApiManager {
    public static readonly albusApis: IAlbusApis = new AlbusApis();
    public static readonly orionApis: IOrionApis = new OrionApis();
    public static readonly polarisApis: IPolarisApis = new PolarisApis();
    public static readonly ramsayApis: IRamsayApis = new RamsayApis();
    public static readonly maverickApis: IMaverickApis = new MaverickApis();
    public static readonly metricServiceApis: IMetricServiceApis = new MetricServiceApis();
    public static readonly subuserServiceApis: ISubuserApis = new SubuserApis();
    public static readonly ollivanderServiceApis = new OllivanderApis();
    public static readonly ehrServiceApis = new EHRApis();
    public static readonly careRecommendationServiceApis = new CareRecommendationServiceApis();
    public static readonly userFitnessApis = new UserFitnessApis();

    public static getAlbusApis(): IAlbusApis {
        return ApiManager.albusApis;
    }

    public static getOrionApis(): IOrionApis {
        return ApiManager.orionApis;
    }

    public static getPolarisApis(): IPolarisApis {
        return ApiManager.polarisApis;
    }

    public static getRamsayApis(): IRamsayApis {
        return ApiManager.ramsayApis;
    }

    public static getMaverickApis(): IMaverickApis {
        return ApiManager.maverickApis;
    }

    public static getMetricServiceApis(): IMetricServiceApis {
        return ApiManager.metricServiceApis;
    }

    public static getSubUserServiceApis(): ISubuserApis {
        return ApiManager.subuserServiceApis;
    }

    public static getOllivanderServiceApis() {
        return ApiManager.ollivanderServiceApis;
    }

    public static getEHRApis(): IEHRApis {
        return ApiManager.ehrServiceApis;
    }

    public static getCareRecommendationServiceApis(): ICareRecommendationServiceApis {
        return ApiManager.careRecommendationServiceApis;
    }

    public static getUserFitnessApis(): IUserFitnessApis {
        return ApiManager.userFitnessApis;
    }
}